/**
 * Downloadable generic .docx starter template for the Company Onboarding
 * "Additional onboarding files" bulk-upload area (Workflow doc slide 5 —
 * Company onboarding; PRD Company Onboarding section).
 *
 * This is a static, unbranded, pre-project template (no Company.branding
 * context exists yet at onboarding time) — same static-asset mechanism as
 * `onboardingSampleArtefacts.js`, deliberately NOT routed through the
 * runtime html-to-docx / stampProjectBranding pipeline (see lesson
 * branding-bypassed-by-html-to-docx: that pipeline is for per-project
 * branded artefacts, which this is not).
 */

const BASE = "/bulk-upload-templates";
const FILE_NAME = "PLITS_TEM_Bulk_Upload_Template_V1.docx";

/**
 * Absolute URL for the static bulk-upload starter .docx (CRA `PUBLIC_URL`
 * prefix when the app is not hosted at root).
 * @returns {string}
 */
export function getBulkUploadTemplateHref() {
  const pub = typeof process !== "undefined" && process.env && process.env.PUBLIC_URL ? String(process.env.PUBLIC_URL) : "";
  const root = pub.replace(/\/$/, "");
  const path = `${BASE}/${encodeURIComponent(FILE_NAME)}`;
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}${root}${path}`;
  }
  return `${root || ""}${path}`;
}

export const BULK_UPLOAD_TEMPLATE_FILE_NAME = FILE_NAME;
